module.exports = __webpack_public_path__ + "img/Profile.2dc4951d.svg";